import { dropdownMapping } from "views/pages/manage/edpOps/constant/common";
import moment from "moment";
import { endpoint } from "views/pages/manage/common/constant";
import { buSubTypeDropDown } from "./constant";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const getDropdowns = async () => {
    const p = await Promise.all([
        dropdownMapping(endpoint.businessType.getAllActiveUnitType, 'businessUnitTypeDispValue', 'id'),
    ])
    return {
        businessUnitType: p[0],
        businessUnitSubType: buSubTypeDropDown
    }
}

export const getFilterFormFields = (reqForm = {}, dropdowns) => {
    const { businessAreas, businessUnitType, businessUnitSubType } = dropdowns || {}
    return [
        {
            label: 'Process Id',
            type: 'text',
            formKey: 'processId',
            onChange: () => { },
            placeholder: "Enter",
        },
        {
            label: 'Business Area',
            type: 'select',
            formKey: 'businessArea',
            items: businessAreas,
            onChange: () => { },
            placeholder: "Select Business Area",
            disabled: false,
            isMulti: true,
            isShowCount: true
        },
        {
            label: 'Business Area Type',
            type: 'select',
            items: businessUnitType,
            formKey: 'businessAreaType',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Payment Method",
            disabled: false,
            isShowCount: true
        },

        {
            label: 'Sub Type',
            type: 'select',
            items: businessUnitSubType,
            formKey: 'subType',
            onChange: () => { },
            loading: false,
            isMulti: true,
            placeholder: "Select Sub Type",
            disabled: false,
            isShowCount: true
        },
        {
            label: 'Process By',
            type: 'text',
            formKey: 'processRunBy',
            onChange: () => { },
            placeholder: "Enter"
        },

        {
            label: 'Process Run From',
            type: 'date',
            formKey: 'processRunFrom',
            onChange: () => { },
            placeholder: "Select date",
            disabled: false,
            minDate: '',
            maxDate: reqForm?.processRunTo || moment(new Date()),
        },
        {
            label: 'Process Run To',
            type: 'date',
            formKey: 'processRunTo',
            onChange: () => { },
            placeholder: "Select date",
            disabled: false,
            minDate: reqForm?.processRunFrom,
            maxDate: moment(new Date()),
        },
    ]
}

export const fetchCommissionReports = async ({ filters, offset, pageSize }) => {
    return await fetchAllPostPromisedData(endpoint.commissionReport.search, { ...filters, page: offset, size: pageSize })
}

export const createCommissionReport = async (reqObj) => {
    return await fetchAllPostPromisedData(endpoint.commissionReport.create, reqObj)
}

export const fetchBusByPid = async (pid) => {
    return await fetchAllPromisedData(endpoint.commissionReport.getBuListByPId(pid))
}

export const fetchBuAndEmailsListByPid = async (pid, page, pageSize) => {
    return await fetchAllPromisedData(`${endpoint.commissionReport.getBuAndEmailsByPId(pid)}?page=${page}&size=${pageSize}`)
}

export const sendEmail = async (reqObj) => {
    return await fetchAllPostPromisedData(endpoint.commissionReport.sendEmail, reqObj)
}

export const sapPosting = async (reqObj) => {
    return await fetchAllPostPromisedData(endpoint.commissionReport.sapPosting, reqObj)
}

export const filterOwnedBu=(businessAreaDropdown, buTypeDropdown)=>{
  const ownBuObj= buTypeDropdown?.find(item=>item?.label=="Owned");
      const filteredOwnedBu = businessAreaDropdown.filter(
        (item) =>
          item.businessUnitTypeId?.[0] != ownBuObj?.value
      );
      return filteredOwnedBu;

}
